import { Link } from "react-router-dom";

export default function ViewAllMonitorsButton() {
    return (
        <Link className="btn btn-sm btn-virtual" to="/my/monitors">
            <i className="bi bi-card-list text-primary me-1" />
            All
        </Link>
    )
}